import { getStatusDescriptionFromStatusValue } from "../../../../../utils/utility";
import { getDateWithSpecificFormat, transformUserAddress } from "../../../../data-transform";

export default function ctQuoteDetailsColumnsSpecification(config) {
    if (!config.data) return null;
    const { quoteList = [], retrievedQuotes = [], selectedCountries = [] } = config.data;

    let result = {};
    let tableData = [];

    quoteList.forEach((quote, index) => {
        let row = [];
        const rowId = `${quote.quoteId}-${index}`;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let displayInCell = true;
            let columnValue = null;
            let columnValueData = null;
            let customEventHandler = null;
            let isDisabled = false;
            let isOverflowingContent = false;
            const isRetrieved = retrievedQuotes[index]?.retrievedQuote;
            const rowDisabled = selectedCountries.length && (!selectedCountries.some(country => country.countryCode === quote.countryCode && country.vendorName === quote.selectedVendor)) || quote.retrievedStatus === "RETRIEVAL_IN_PROGRESS";
            const isDealClosed = config.data.dealStatus === "COMPLETED";
            const legalEnetityOptions = quote.legalEntityIds ? quote.legalEntityIds.map(legalEntityId => ({ id: legalEntityId, label: legalEntityId })) : [];
            const shippingDetailsOptions = [
                { id: "1", label: "Collection" },
                { id: "2", label: "Self shipment" }
            ];
            const logisticsServiceOptions = [
                { id: "Standard Logistics Service", label: "Standard" },
                { id: "Special Logistics Service", label: "Special" }
            ];
            const processingServiceOptions = [
                { id: "Offsite data sanitization", label: "Offsite" },
                { id: "Onsite data sanitization", label: "Onsite" }
            ];
            if (columnDataType === "string") {
                if (columnId === "quoteId") {
                    columnValue = quote.quoteId || "";
                }
                else if (columnId === "customerName") {
                    columnValue = quote.customerName || "";
                }
                else if (columnId === "orgId") {
                    columnValue = quote.orgId || "";
                }
                else if (columnId === "createdDate") {
                    columnValue = quote.createdDate ? getDateWithSpecificFormat(quote.createdDate) : "";
                }
                else if (columnId === "totalDevicesQuoted") {
                    columnValue = quote.totalDevicesQuoted || "";
                }
                else if (columnId === "countryCode") {
                    columnValue = quote.countryCode || "";
                }
                else if (columnId === "retrievedStatus") {
                    columnValue = quote.retrievedStatus ? getStatusDescriptionFromStatusValue(quote.retrievedStatus) : "";
                }
                else if (columnId === "cnetValue") {
                    columnValue = quote.cnetValue || "";
                }
                else if (columnId === "selectedVendor") {
                    columnValue = quote.selectedVendor || "";
                }
            }
            else if (columnDataType === "selectionCheckBox") {
                if (column.id === "retrievedQuote") {
                    columnValue = quote.retrievedQuote || false;
                }
                isDisabled = isRetrieved;
                customEventHandler = config.bodyButtonsHandler.inputChangeCTQuoteDetails ? event => config.bodyButtonsHandler.inputChangeCTQuoteDetails(event, columnId, quote.quoteId, index) : null
            }

            if (columnDataType === "select") {
                if (columnId === "legalEntityId") {
                    columnValue = quote.legalEntityId || "";
                    columnValueData = { ...column.data };
                    columnValueData.options = [{ id: "", label: "Select legal entity" }, ...legalEnetityOptions];
                    columnValueData.defaultValue = columnValue;
                    isDisabled = isRetrieved || rowDisabled || false;
                }
                else if (columnId === "orderType") {
                    columnValue = quote.orderType || "";
                    columnValueData = { ...column.data };
                    columnValueData.options = [{ id: "", label: "Select shipping details" }, ...shippingDetailsOptions];
                    columnValueData.defaultValue = columnValue;
                    isDisabled = isRetrieved || rowDisabled || false;
                }
                else if (columnId === "logisticServiceRequested") {
                    columnValue = quote.logisticServiceRequested || "";
                    columnValueData = { ...column.data };
                    columnValueData.options = [{ id: "", label: "Select logistics service" }, ...logisticsServiceOptions];
                    columnValueData.defaultValue = columnValue;
                    isDisabled = isRetrieved || rowDisabled || false;
                }
                else if (columnId === "processingServiceRequested") {
                    columnValue = quote.processingServiceRequested || "";
                    columnValueData = { ...column.data };
                    columnValueData.options = [{ id: "", label: "Select processing service" }, ...processingServiceOptions];
                    columnValueData.defaultValue = columnValue;
                    isDisabled = isRetrieved || rowDisabled || false;
                }
                customEventHandler = config.bodyButtonsHandler.inputChangeCTQuoteDetails ? event => config.bodyButtonsHandler.inputChangeCTQuoteDetails(event, columnId, quote.quoteId, index) : null
            }

            else if (columnDataType === "editIconWithText") {
                if (columnId === 'collectionAddress') {
                    const addressObj = quote.collectionAddress
                        ? Object.fromEntries(Object.entries(quote.collectionAddress).map(([k, v]) => [k, v === null ? "" : v]))
                        : quote.collectionAddress;
                    const addressString = transformUserAddress(addressObj).join(", ");
                    const actionType = "add";
                    const collectionAddressData = quote.collectionAddress;
                    const editButton = {
                        type: "icon",
                        endIcon: "edit",
                        iconStyle: { width: "20px", height: "20px" },
                        labelId: actionType,
                        isVisible: isRetrieved || rowDisabled ? false : true,
                        clickHandler: config.bodyButtonsHandler.editAddressHandler ? (event) => config.bodyButtonsHandler.editAddressHandler(actionType, quote.quoteId, index) : null
                    };

                    const deleteButton = {
                        type: "icon",
                        endIcon: "delete",
                        iconStyle: { width: "20px", height: "20px" },
                        labelId: "delete",
                        isVisible: addressString && !isRetrieved && !rowDisabled ? true : false,
                        clickHandler: config.bodyButtonsHandler.handleDeleteLegalEntityRowAction ? (event) => config.bodyButtonsHandler.handleDeleteLegalEntityRowAction(actionType, quote.quoteId, index) : null
                    }

                    columnValue = {
                        value: addressString,
                        buttons: [editButton, deleteButton]
                    }
                }

            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    displayInCell: displayInCell,
                    value: columnValueData || columnValue,
                    disabledCell: isDisabled || rowDisabled || isDealClosed,
                    disabled: isDisabled || isDealClosed,
                    bgColor: (rowDisabled || isDealClosed) ? "#dbdbdb" : null,
                    isOverflowingContent: isOverflowingContent,
                    clickHandler: (columnDataType !== "string" && customEventHandler) ? customEventHandler : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}